import AppLabelElementContainer from '../../../components/AppLabelElementContainer'
import AppSelect, {OptionObjInterface} from '../../../components/AppSelect'

type FiltersProps = {
  selectedClient: string
  selectedSite: string
  clientDropdownOptions: OptionObjInterface[]
  siteDropdownOptions: OptionObjInterface[]
  handleClientChange: (client: string) => void
  handleSiteChange: (client: string) => void
}

const Filters = ({
  selectedClient,
  selectedSite,
  clientDropdownOptions,
  handleClientChange,
  siteDropdownOptions,
  handleSiteChange,
}: FiltersProps) => {
  const hasClients = clientDropdownOptions?.length > 0
  return !hasClients ? null : (
    <div className='pb-4 mb-4 d-flex justify-content-around align-items-center gap-20'>
      <div className='flex-fill' style={{width: '50%'}}>
        <AppLabelElementContainer>
          <label className='h3'>Client</label>
          <AppSelect
            data={clientDropdownOptions}
            placeholder='Select Client'
            onChange={handleClientChange}
            className='mb-2'
          />
        </AppLabelElementContainer>
      </div>

      <div className='flex-fill' style={{width: '50%'}}>
        <AppLabelElementContainer>
          <label className='h3'>Site</label>
          <AppSelect
            data={siteDropdownOptions}
            placeholder='Select Site'
            onChange={handleSiteChange}
            className='mb-2'
          />
        </AppLabelElementContainer>
      </div>
    </div>
  )
}

export default Filters
